import React from 'react';
import styled from 'styled-components';

import StyledPageContent from '../components/StyledPage';
import InputImageCrop from '../components/InputImageCrop';
import Button from '../components/Button';
import InputFileUpload from '../components/InputFileUpload'

import { useForm } from 'react-hook-form';

const StyledPage = styled(StyledPageContent)`
    .field {
        margin: 24px 0;
    }
`;

export default  () => {
    const { register, handleSubmit,  formState: { errors } } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    }


    return (
        <StyledPage>
            <h1>Crop demo</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <InputImageCrop name="photo" ref={register} config={{width: 250, height: 350, output: {width: 250, height: 350}}} />

                <InputFileUpload label="Seleccionar archivo" name="file" ref={register}/>

                <Button type="submit">Enviar</Button>
            </form>

        </StyledPage>
    );
};

